import { useEffect } from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { AnimatedBackground } from "@/components/AnimatedBackground";

export default function Status() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://uptime.betterstack.com/widgets/announcement.js";
    script.setAttribute("data-id", "228960");
    script.async = true;
    script.type = "text/javascript";
    
    document.body.appendChild(script);
    
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="relative min-h-screen bg-background">
      <AnimatedBackground opacity={0.1} />
      
      {/* Public Header */}
      <header className="relative z-10 border-b border-border/40 bg-background/80 backdrop-blur-sm">
        <div className="container mx-auto px-4 py-4">
          <Link to="/" className="inline-block">
            <Logo size={40} />
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="relative z-10 container mx-auto px-4 py-8">
        <div className="max-w-5xl mx-auto">
          <div className="mb-8">
            <h1 className="text-3xl font-bold mb-2">System Status</h1>
            <p className="text-muted-foreground">
              Real-time status and uptime information for all DebtNet services
            </p>
          </div>
          
          <div id="betterstack-status-widget" className="bg-card rounded-lg border border-border overflow-hidden shadow-sm p-6">
            {/* BetterStack widget will render here */}
          </div>
        </div>
      </main>
    </div>
  );
}
